import * as React from "react";
import {cx} from "emotion";

import "./naming-panel.scss";

import {bindInput}   from "@Common/react/bind-input";
import {cs}          from "@Common/react/chain-services";
import {scopedState} from "@Common/react/scoped-state";

import {Checkbox}         from "../../../../../common/design2/checkbox/checkbox";
import {InformationBadge} from "../../../../../common/design2/information-badge/information-badge";
import {Select}           from "../../../../../common/design2/select/select";
import {RadioOption}      from "../radio-option/radio-option";

export const NamingPanel = ({data, customNameCss=null, showErrors, controls=undefined, xdQaName=undefined}) => cs(
    () => (
        <div className="naming-panel-45d">
            <div className="dual-panel">
                <div className="left" xd-qa-type="label" xd-qa-name={xdQaName+" Assign Names Description"}>
                    Choose how you want the resident to appear for addresses you have selected.

                    {data?.value?.type === 'custom' ? (
                        <div className="additional-info">
                            <div className="heading-section" xd-qa-type="label" xd-qa-name="Not recommended for Replace name"><img className="address-image" src='/next_images/Address-Warning.svg'/>{"Not recommended for"}</div>
                            <div className="list-section" xd-qa-type="label" xd-qa-name="Capturing leads on your Lead Analytics Dashboard">
                                Capturing leads on your Lead Analytics Dashboard, as original recipient names will be replaced.
                            </div>
                        </div>
                    ) : (
                        <div className="additional-info">
                            <div className="heading-section" xd-qa-type="label" xd-qa-name="Good for"><img className="address-image" src='/next_images/Address-Success.svg'/>{"Good for"}</div>
                            <ul className="list-section">
                                <li xd-qa-type="label" xd-qa-name="Improved deliverability rate and reduced returned mail">
                                    Improved deliverability rate and reduced returned mail
                                </li>
                                <li xd-qa-type="label" xd-qa-name="Delivering to the address and not the person">
                                    Delivering to the address and not the person
                                </li>
                                <li xd-qa-type="label" xd-qa-name="Apartments due to high residency turnover">
                                    Apartments due to high residency turnover
                                </li>
                            </ul>
                            <div className="heading-section" xd-qa-type="label" xd-qa-name="Not recommended for Use resident name"><img className="address-image" src='/next_images/Address-Warning.svg'/>{"Not recommended for"}</div>
                            <ul className="list-section">
                                <li xd-qa-type="label" xd-qa-name="PO Box addresses">
                                    PO Box addresses
                                </li>
                                <li xd-qa-type="label" xd-qa-name="Areas with high seasonal residency">
                                    Areas with high seasonal residency
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
                <div className="right">
                    {RadioOption({
                        label: "Use resident name",
                        selected: ["owner", ...ownerOptions].includes(data.value.type),

                        onSelect: () => data.onChange({type: "owner"}),
                        xdQaName: "Use resident name",
                    })}
                    <div className="options">
                        {["owner", ...ownerOptions].includes(data.value.type) && (
                            <div
                                className="apply-to-owner-section"
                            >
                                <div className="checkbox-line" 
                                    onClick={() => {
                                        if(ownerOptions.includes(data.value.type)) {
                                            data.onChange({type: "owner"});
                                        } else {
                                            data.onChange({type: "or_resident"});
                                        }
                                    }}
                                >
                                    {Checkbox({
                                        checked: ownerOptions.includes(data.value.type),
                                        xdQaName: "Add"
                                    })}
                                    <div className="add-label">
                                        Add
                                    </div>
                                </div>
                                {Select({
                                    forcedExpandLeft: true,
                                    disabled: !ownerOptions.includes(data.value.type),
                                    className: 'address-options-select',
                                    list: ownerOptions.map((value) => ({
                                        value,
                                        label: value.replace("_", " ").toUpperCase(),
                                    })),
                                    itemToLabel: (e) => e?.label,
                                    onChange: (e) => data.onChange({type: e.value}),
                                    isSelected: (e) => data.value.type == e.value,
                                    xdQaName: "Use resident additional options type"
                                })}
                                <span style={{marginLeft: "5px", marginTop: "7px"}}>
                                    {InformationBadge({
                                        getTooltip: () => "Appears below resident name",
                                        xdQaName: "Select options tooltip",
                                    })}
                                </span>
                            </div>
                        )}
                    </div>

                    {RadioOption({
                        label: "Replace name",
                        selected: data.value.type === "custom",
                        extra: data.value.type === "custom" && (
                            <input {...{
                                autoFocus: true,
                                placeholder: "Custom name...",
                                maxLength: 50,
                                className: cx(customNameCss, {hasError: showErrors && !data.value.value}),
                                ...bindInput(scopedState(data, ["value"])),
                                "xd-qa-type": "text_field",
                                "xd-qa-name": xdQaName + " Replace name",
                            }}/>
                        ),

                        onSelect: () => data.onChange({type: "custom"}),
                        xdQaName: "Replace Name",
                    })}
                </div>
            </div>
            <div className="dual-panel">
                <div className="left" xd-qa-type="label"></div>
                <div className="right">
                    {controls}
                </div>
            </div>
        </div>
    ),
);

const ownerOptions = [
    "or_resident",
    "or_occupant",
    "or_homeowner",
];


